import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';

export const sharedWallet = [
	{
		path: '/shared-wallet/',
		Component: withFeatureFlag(withProtected(lazy(() => import('../pages/SharedWallet'))), 'shared-wallet-enabled'),
		children: [
			{
				path: '/shared-wallet/',
				Component: lazy(() => import('../pages/SharedWallet/Requests')),
				handle: {
					key: 'pages.sharedWallet.title'
				}
			},
			{
				path: '/shared-wallet/:requestId',
				Component: lazy(() => import('../pages/SharedWallet/Request')),
				handle: {
					key: 'pages.sharedWallet.title'
				}
			},
			{
				path: '/shared-wallet/:requestId/submit',
				Component: lazy(() => import('../pages/SharedWallet/Submit')),
				handle: {
					key: 'pages.sharedWallet.title'
				}
			}
		]
	}
];
